export const defaultStartupLogo = require('../../../assets/images/cards/teia-card-header/logo.png');
